import React from "react";
import { PageWrapper} from "../layout/page-wrapper/page-wrapper";
import { GlobalStyle } from "./styles";

export default function App() {
  return (
    <>
      <GlobalStyle />
      <PageWrapper />
    </>
  );
}
